
import React, { createContext, ReactNode, useContext } from "react";

export type RegionProps = {
  selectedRegion: Record<string, any> | null;
  setSelectedRegion: React.Dispatch<
    React.SetStateAction<Record<string, any> | null>>;
};
export const RegionContext = createContext<RegionProps | null>({} as RegionProps);

export function useRegion() {
  const ctx = useContext(RegionContext);
  return ctx;
}
export default function RegionProvider({
  value,
  children,
}: {
  value: RegionProps;
  children: ReactNode;
}): JSX.Element {
  return (
    <RegionContext.Provider value={value}>{children}</RegionContext.Provider>
  );
}
